import React, { useState, useEffect } from 'react';

// Wspólny komponent zakładek - używany wszędzie tam, gdzie strona ma podział na
// karty/sekcje (Ustawienia, Menu, itd.). Automatycznie przełącza się na <select>
// poniżej 768px szerokości ekranu, żeby zakładki nie ściskały się w nieskończoność
// na wąskich ekranach/tabletach.
//
// Użycie:
//   <TabBar tabs={[{ id: 'general', label: '🏢 Ogólne' }, ...]} active={tab} onChange={setTab} />
export default function TabBar({ tabs, active, onChange }) {
  const [isNarrow, setIsNarrow] = useState(() => window.innerWidth < 768);

  useEffect(() => {
    function onResize() { setIsNarrow(window.innerWidth < 768); }
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  if (isNarrow) {
    return (
      <select className="tabs-bar-select" value={active} onChange={e => onChange(e.target.value)}>
        {tabs.map(t => <option key={t.id} value={t.id}>{t.label}</option>)}
      </select>
    );
  }

  return (
    <div className="tabs-bar">
      {tabs.map(t => (
        <button key={t.id} onClick={() => onChange(t.id)}
          className={`tabs-bar-btn${active === t.id ? ' active' : ''}`}>
          {t.label}
        </button>
      ))}
    </div>
  );
}
